<template>
  <div class="ShopCart">
    <div class="ShopCart-background">
        <div class="ShopCart-title">购物车<img src="../../public/obraoag/appReturnaa.png" alt="" @click="appHelmetreturn()"></div>
        <div class="ShopCart-fill"></div>
        <div v-if="shopProist != ''">
          <div class="ShopCart-sopping" v-for="eishopProist in shopProist" :key="eishopProist.ID">
            <div class="ShopCart-sopping-pkeepr">
              <div class="ShopCart-comity-left">
                <el-checkbox v-model="eishopProist.IS_NOT_CHECK" @change="psCalcrece(eishopProist.goods,eishopProist.IS_NOT_CHECK)"></el-checkbox>
              </div>
              <span class="ShopCart-sopping-pkeepr-srname">{{eishopProist.NAME}}</span>
            </div>
            <div class="ShopCart-comity" v-for="ereishopProist in eishopProist.goods" :key="ereishopProist.ID">
              <div class="ShopCart-comity-left">
                <el-checkbox v-model="ereishopProist.IS_NOT_CHECK" @change="Calcrece(ereishopProist.ID,ereishopProist.IS_NOT_CHECK)"></el-checkbox>
              </div>
              <div class="ShopCart-comity-right">
                  <div class="ShopCart-comity-right-img">
                      <router-link :to="{path:'commodity',query:{hmComyID: ereishopProist.GOODS_ID}}">
                          <img :src="ereishopProist.GOODS_IMAGE" alt="">
                      </router-link>
                  </div>
                  <div class="ShopCart-comity-right-content">
                      <router-link :to="{path:'commodity',query:{hmComyID: ereishopProist.GOODS_ID}}">
                          <div class="ShopCart-comity-right-cttile">{{ereishopProist.goodsName}}</div>
                      </router-link>
                      <div class="ShopCart-comdity-number">
                          <p class="ShopCart-comdity-number-text">
                            <span class="ShopCart-comdity-number-tenuer">￥{{ereishopProist.MARKET_PRICE}}</span>
                          </p>
                          <div class="ShopCart-comdity-number-purchase">
                              <p class="ShopCart-comdity-number-puce" @click.stop="shopreduce(ereishopProist.ID,ereishopProist.SPECIF_ID)">
                                  <img src="../../public/obraoag/commodityreduce.png" alt="">
                              </p>
                              <p class="ShopCart-comdity-number-puxt">{{ereishopProist.SHOPPING_NUMBER}}</p>
                              <p class="ShopCart-comdity-number-puus" @click.stop="shopincrse(ereishopProist.ID,ereishopProist.SPECIF_ID)">
                                  <img src="../../public/obraoag/commodityplus.png" alt="">
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="BuCardModel-bankcard-beemptygw" v-else>您的购物车里没有商品,快去添加吧</div>
        <div class="ShopCart-fill"></div>
        <div class="ShopCart-fill"></div>
        <div class="ShopCart-Imment">
            <div class="ShopCart-Imment-left">
                <el-checkbox v-model="shopSelall" @change="shopJuerll()">全选</el-checkbox>
            </div>
            <div class="ShopCart-Imment-right">
                <span class="ShopCart-Immedment-left-title">实付:</span>
                <span class="ShopCart-Immedment-left-number">{{Totarice}}</span>
                <span class="ShopCart-Immedment-left-text">免运费</span>
                <button @click="shopChrt()">去结算</button>
            </div>
        </div>
    </div>
    <botgaion snatus="2"></botgaion>
    <!-- 微信WeUI样式 -->
    <div id="toast" :style="'display:' + shopAppden">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{shopConnts}}</p>
      </div>
    </div>
    <div class="js_dialog" id="iosDialog1" :style="'display:' + shmmasad">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">您还没有收货地址哦,赶快去设置一个吧!</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="shmmfoen()">取消</a>
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #616592;" @click="shmmRete()">去设置</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      shopched: false,
      shopAppden: 'none',
      shopConnts: '',
      customerID: '',
      shopProist: '',
      shopSelall: false,
      Totarice: 0,
      Tomersce: 0,
      Toinprce: 0,
      maluerID: '',
      shmmasad: 'none',
      shmmSeless: ''
    }
  },
  created(){
    // 从缓存中获取用户token
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 通过拼接用户ID获取用户地址信息
    this.$axios.post('wx/addressList',this.$qs.stringify({
      WECHAT_FLAG: 'OBLYYKT',
      MEMBER_ID: this.customerID,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.shmmSeless = res.data.default;
    })
    // 获取商品信息
    this.$axios.post('wx/shopcart/list',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      showCount: '10',
      currentPage: '1',
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.shopProist = res.data.varList;
      for(var i in this.shopProist){
        var shcouter = 0;
        this.$set(this.shopProist[i],'IS_NOT_CHECK',false)
        for(var j in this.shopProist[i].goods){
          if(this.shopProist[i].goods[j].IS_NOT_CHECK == '0'){
            shcouter += 1
            this.$set(this.shopProist[i].goods[j],'IS_NOT_CHECK',true)
            if(shcouter == this.shopProist[i].goods.length){
              this.$set(this.shopProist[i],'IS_NOT_CHECK',true)
            }
          }else{
            this.$set(this.shopProist[i].goods[j],'IS_NOT_CHECK',false)
          }
        }
      }
      this.Calcrice()
      this.shopJudall()
    })
    .catch(() => {
        // console.log('未登录获取数据失败');
    });
  },
  mounted(){
    
  },
  methods:{
    // 点击减少
    shopreduce(Incitb,Speons){
      for(var i in this.shopProist){
        for(var j in this.shopProist[i].goods){
          if (Incitb == this.shopProist[i].goods[j].ID){
            if(this.shopProist[i].goods[j].SHOPPING_NUMBER > 1){
              this.shopProist[i].goods[j].SHOPPING_NUMBER = parseInt(this.shopProist[i].goods[j].SHOPPING_NUMBER) - 1;
              // 传递选中商品的ID和当前数量
              this.$axios.post('wx/updateShopingNumber',this.$qs.stringify({
                ID: Incitb,
                SPECIF_ID: Speons,
                SHOPPING_NUMBER: this.shopProist[i].goods[j].SHOPPING_NUMBER,
                MALL_TYPE: this.maluerID
              }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
              .then(res => {
                console.log(res.data)
              })
              .catch(() => {
                  // console.log('未登录获取数据失败');
              });
              // console.log(this.shopProist[i].goods[j].SHOPPING_NUMBER)
            }else{
              this.shopConnts = '最少购买一件哦!'
              this.shopAppden = 'block'
              let that = this
              setTimeout(function(){
                that.shopAppden = 'none'
              },1400)
            }
          }
        }
        
      }
      this.Calcrice()
    },
    // 点击增加
    shopincrse(Incity,Speony){
      for(var i in this.shopProist){
        for(var j in this.shopProist[i].goods){
          if (Incity == this.shopProist[i].goods[j].ID){
            this.shopProist[i].goods[j].SHOPPING_NUMBER = parseInt(this.shopProist[i].goods[j].SHOPPING_NUMBER) + 1;
            // 传递选中商品的ID和当前数量
            this.$axios.post('wx/updateShopingNumber',this.$qs.stringify({
              ID: Incity,
              SPECIF_ID: Speony,
              SHOPPING_NUMBER: this.shopProist[i].goods[j].SHOPPING_NUMBER,
              MALL_TYPE: this.maluerID
            }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
            .then(res => {
              console.log(res.data)
            })
            .catch(() => {
                // console.log('未登录获取数据失败');
            });
          }
        }
      }
      this.Calcrice()
    },
    // 计算价格
    Calcrice(){
      this.Totarice = 0
      this.Tomersce = 0
      this.Toinprce = 0
      for(var i in this.shopProist){
        for(var j in this.shopProist[i].goods){
          if(this.shopProist[i].goods[j].IS_NOT_CHECK == true){
            this.Totarice += Number(this.shopProist[i].goods[j].MARKET_PRICE) * Number(this.shopProist[i].goods[j].SHOPPING_NUMBER)
            this.Tomersce += Number(this.shopProist[i].goods[j].MEMBER_PRICE) * Number(this.shopProist[i].goods[j].SHOPPING_NUMBER)
            this.Toinprce += Number(this.shopProist[i].goods[j].NTEGRAL_PRICE) * Number(this.shopProist[i].goods[j].SHOPPING_NUMBER)
          }
        }
      }
      // console.log(this.Totarice)
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1)
    },
    // 判断是否全选
    shopJudall(){
      var shopnum = 0
      for(var i in this.shopProist){
        if(this.shopProist[i].IS_NOT_CHECK == true){
          shopnum = shopnum + 1
        }
      }
      if(this.shopProist.length == shopnum){
        this.shopSelall = true
      }else{
        this.shopSelall = false
      }
    },
    // 点击全选
    shopJuerll(){
      this.Totarice = 0
      this.Tomersce = 0
      this.Toinprce = 0
      var shopctalID = ''
      for(var i in this.shopProist){
        this.$set(this.shopProist[i],'IS_NOT_CHECK',this.shopSelall)
        for(var j in this.shopProist[i].goods){
          shopctalID += this.shopProist[i].goods[j].ID + ','
          this.$set(this.shopProist[i].goods[j],'IS_NOT_CHECK',this.shopSelall)
          if(this.shopProist[i].goods[j].IS_NOT_CHECK == true){
            this.Totarice += Number(this.shopProist[i].goods[j].MARKET_PRICE) * Number(this.shopProist[i].goods[j].SHOPPING_NUMBER)
            this.Tomersce += Number(this.shopProist[i].goods[j].MEMBER_PRICE) * Number(this.shopProist[i].goods[j].SHOPPING_NUMBER)
            this.Toinprce += Number(this.shopProist[i].goods[j].NTEGRAL_PRICE) * Number(this.shopProist[i].goods[j].SHOPPING_NUMBER)
          }
        }
      }
      // 点击全选选择全部商品
      this.$axios.post('wx/isNotCheck',this.$qs.stringify({
        ID: shopctalID,
        IS_NOT_CHECK: this.shopSelall ? 0 : 1,
        MALL_TYPE: this.maluerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        console.log(res.data)
      })
      .catch(() => {
          // console.log('未登录获取数据失败');
      });
    },
    // 点击单选
    Calcrece(shopciID,shopflag){
      for(var i in this.shopProist){
        var shcouter = 0;
        for(var j in this.shopProist[i].goods){
          if(this.shopProist[i].goods[j].IS_NOT_CHECK){
            shcouter += 1
            if(shcouter == this.shopProist[i].goods.length){
              this.$set(this.shopProist[i],'IS_NOT_CHECK',true)
            }else{
              this.$set(this.shopProist[i],'IS_NOT_CHECK',false)
            }
          }
        }
      }
      // 点击单选选择商品
      this.$axios.post('wx/isNotCheck',this.$qs.stringify({
        ID: shopciID,
        IS_NOT_CHECK: shopflag ? 0 : 1,
        MALL_TYPE: this.maluerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        console.log(res.data)
      })
      .catch(() => {
          // console.log('未登录获取数据失败');
      });
      this.shopJudall()
      this.Calcrice()
    },

    // 店铺全选
    psCalcrece(sitopy,soreus){
      var shopctalID = ''
      for(var e in sitopy){
        shopctalID += sitopy[e].ID + ','
        this.$set(sitopy[e],'IS_NOT_CHECK',soreus)
      }
      this.Calcrice()
      this.shopJudall()
      // 点击全选选择全部商品
      this.$axios.post('wx/isNotCheck',this.$qs.stringify({
        ID: shopctalID,
        IS_NOT_CHECK: soreus ? 0 : 1,
        MALL_TYPE: this.maluerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        console.log(res.data)
      })
      .catch(() => {
          // console.log('未登录获取数据失败');
      });
    },



    // 点击去结算
    shopChrt(){
      var sopcoray = []
      for(var i in this.shopProist){
        var soitcdem = []
        for(var j in this.shopProist[i].goods){
          if(this.shopProist[i].goods[j].IS_NOT_CHECK == true){
            var stojctym = {}
            this.$set(stojctym,'SPECIF_ID',this.shopProist[i].goods[j].SPECIF_ID)
            this.$set(stojctym,'SHOPPING_NUMBER',this.shopProist[i].goods[j].SHOPPING_NUMBER)
            this.$set(stojctym,'ID',this.shopProist[i].goods[j].ID)
            soitcdem.push(stojctym)
          }
        }
        var soptobct = {}
        this.$set(soptobct,'MEMBER_ID',this.customerID)
        this.$set(soptobct,'NAME',this.shopProist[i].NAME)
        this.$set(soptobct,'USER_ID',this.shopProist[i].USER_ID)
        this.$set(soptobct,'goods',soitcdem)
        sopcoray.push(soptobct)
      }
      if(this.shmmSeless == ''){
        this.shmmasad = 'block';
      }else{
        if(this.Totarice != '0'){
          this.$router.push({name: 'Fillrder',query: {sharmyte: JSON.stringify(sopcoray),shltprmc: this.Totarice,shmebsce: this.Tomersce,shtealpe: this.Toinprce}});
        }
      }
    },
    // 点击取消关闭设置地址提示
    shmmfoen(){
      this.shmmasad = 'none';
    },
    // 点击去设置跳转
    shmmRete(){
      this.shmmasad = 'none';
      this.$router.push({name: 'NewAddress'});
    },
  }
}
</script>
<style scoped>
  @import "obraocs/ShopCart.css";
</style>